angular.module('core')
    .directive('dblAssignmentTypeSwitch', [function() {

    return {
        restrict: 'E',
        scope: {
            dblAssignmentType: '='
        },
        templateUrl: '/resources/core/directives/assignment-type-switch/dbl-assignment-type-switch.directive.html',
        controller: ['$element', '$scope', function ($element, $scope) {
            $element.find('input[name="switch_assignment_type"]').change(function(){
                $scope.dblAssignmentType = this.value;

                $scope.$apply(function() {
                    $('#duration_selector').val();
                });
            });
        }]
    };
}]);
